














import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../domain/editableFormat";
import { QuestionnaireGuidTree } from "../../../../domain/questionnaire";
import { FormatPageObjectEditableMixin } from "../mixins";
import { ObjectUpdatesPromptableMixin } from "./trackers/mixins";
import { default as QuestionnaireFormatObjectDrawer } from "./QuestionnaireFormatObjectDrawer.vue";

@Component({
  components: {
    QuestionnaireFormatObjectDrawer,
  }
})
export default class QuestionnaireFormatPageObjectDrawer extends Mixins(ModelEditableMixin, FormatPageObjectEditableMixin, ObjectUpdatesPromptableMixin) {
  @Prop({ default: () => [] as QuestionnaireGuidTree<IFormatObjectEditable>[] })
  treeItems: QuestionnaireGuidTree<IFormatObjectEditable>[];

  onMouseDowned(event: PointerEvent) {
    // オブジェクトの選択はここでハンドリング.(伝搬も止めてる.)
    // (重なりがおかしかったらフォーマット編集の段階で気付けるよう必ず上のオブジェクトが拾う.本体で既存フォーマットを救うために行ってた複雑な制御はしない.)
    if (this.object.isSelected()) {
      return; // 選択中なのでドラッグのはず.無視する.
    }
    this.promptForObjectUpdates(event);
    if (!event.ctrlKey) {
      this.reselectObjects(this.object);
    } else {
      this.selectObjects(this.object);
    }
  }

  onMouseDownCaptured(event: PointerEvent) {
    this.mouseDownCaptured(this.object, event);
  }

  @Emit()
  mouseDownCaptured(source: IFormatObjectEditable, event: PointerEvent) {}

  @Emit()
  dragHandleSelected(source: IFormatObjectEditable, event: PointerEvent): void {}
}
